import type { ApolloError } from '@apollo/client';
import type { GraphQLError } from 'graphql';

import { defaultLocalStorageAdapter } from 'src/shared/graphql';
import { useOnboardingCreateHomeownerUserMutation } from 'src/shared/graphql/generated';
import { useRefreshSession } from 'src/shared/graphql/hooks';

export interface SignUpFromEmbedResponse {
  userCreated: boolean;
  errors: readonly GraphQLError[] | undefined;
}

export const useSignUpFromEmbed = (): ((
  email: string,
) => Promise<SignUpFromEmbedResponse>) => {
  const [createUser] = useOnboardingCreateHomeownerUserMutation();
  const refreshSession = useRefreshSession();

  return async (email: string) => {
    const response: SignUpFromEmbedResponse = {
      userCreated: false,
      errors: undefined,
    };

    try {
      const { data } = await createUser({
        variables: {
          args: { user: { email: email || '' } },
        },
      });
      if (data?.onboardingCreateHomeownerUser?.jwt) {
        const { accessToken, refreshToken } =
          data.onboardingCreateHomeownerUser.jwt;
        await defaultLocalStorageAdapter.setAccessToken(accessToken);
        await defaultLocalStorageAdapter.setRefreshToken(refreshToken);
        await refreshSession();

        response.userCreated = true;
      }
    } catch (e) {
      const error = e as ApolloError;
      response.errors = error.graphQLErrors;
    }

    return response;
  };
};
